export default __webpack_public_path__ + "static/YELLOW_GLOW_BG-e2871b00b5d04602c945428126d9b8ae.png";